import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import {LaddaModule} from 'angular2-ladda';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { PipesModule } from '../../../pipes/pipes.module';
import { ComponentModule } from '../../../components/components.module';
import { TimeTrackingReportStates } from './time-tracking-print-reports.states';
import { TimeTrackingPrintReportComponent } from './time-tracking-print-report/time-tracking-print-report.component';
import { EdlCommonComponentsModule, EdlCommonDirectiveModule, EdlCommonPipesModule, EdlDatePickerModule } from '@edl-development/edl-common';
import { ComplyDirectivesModule } from 'src/app/directives/comply-directives.module';

@NgModule({
    imports: [
        CommonModule,
        UIRouterModule.forChild({
            states: TimeTrackingReportStates
        }),
        FormsModule,
        ReactiveFormsModule,
        EdlCommonDirectiveModule,
        ComplyDirectivesModule,
        LaddaModule,
        NgbModule,
        EdlCommonPipesModule,
        PipesModule,
        ComponentModule,
        EdlCommonComponentsModule,
        EdlDatePickerModule
    ],
    declarations: [
        TimeTrackingPrintReportComponent
    ]
})
export class TimeTrackingPrintReportsModule {}